/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { OrganizationApiConfiguration as __Configuration } from '../organization-api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { ListQueryResultDistrictInfo } from '../models/list-query-result-district-info';
import { CreateDistrictCommand } from '../models/create-district-command';
import { UpdateDistrictCommand } from '../models/update-district-command';
@Injectable({
  providedIn: 'root',
})
class DistrictService extends __BaseService {
  static readonly GetAllPath = '/api/organization/districts';
  static readonly CreateDistrictPath = '/api/organization/districts';
  static readonly GetUpdateDistrictPath = '/api/organization/districts/{id}/update';
  static readonly UpdateDistrictPath = '/api/organization/districts/{id}/update';
  static readonly DeleteDistrictPath = '/api/organization/districts/{id}';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param params The `DistrictService.GetAllParams` containing the following parameters:
   *
   * - `sortFields`:
   *
   * - `sortCriteria`:
   *
   * - `pattern`:
   *
   * - `pageSize`:
   *
   * - `pageNumber`:
   *
   * - `governorateId`:
   *
   * @return Success
   */
  GetAllResponse(params: DistrictService.GetAllParams): __Observable<__StrictHttpResponse<ListQueryResultDistrictInfo>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    (params.sortFields || []).forEach(val => {if (val != null) __params = __params.append('sortFields', val.toString())});
    (params.sortCriteria || []).forEach(val => {if (val != null) __params = __params.append('sortCriteria', val.toString())});
    if (params.pattern != null) __params = __params.set('pattern', params.pattern.toString());
    if (params.pageSize != null) __params = __params.set('pageSize', params.pageSize.toString());
    if (params.pageNumber != null) __params = __params.set('pageNumber', params.pageNumber.toString());
    if (params.governorateId != null) __params = __params.set('governorateId', params.governorateId.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/organization/districts`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<ListQueryResultDistrictInfo>;
      })
    );
  }
  /**
   * @param params The `DistrictService.GetAllParams` containing the following parameters:
   *
   * - `sortFields`:
   *
   * - `sortCriteria`:
   *
   * - `pattern`:
   *
   * - `pageSize`:
   *
   * - `pageNumber`:
   *
   * - `governorateId`:
   *
   * @return Success
   */
  GetAll(params: DistrictService.GetAllParams): __Observable<ListQueryResultDistrictInfo> {
    return this.GetAllResponse(params).pipe(
      __map(_r => _r.body as ListQueryResultDistrictInfo)
    );
  }

  /**
   * @param command undefined
   */
  CreateDistrictResponse(command?: CreateDistrictCommand): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = command;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/organization/districts`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * @param command undefined
   */
  CreateDistrict(command?: CreateDistrictCommand): __Observable<null> {
    return this.CreateDistrictResponse(command).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * @param id undefined
   * @return Success
   */
  GetUpdateDistrictResponse(id: string): __Observable<__StrictHttpResponse<UpdateDistrictCommand>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/organization/districts/${id}/update`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<UpdateDistrictCommand>;
      })
    );
  }
  /**
   * @param id undefined
   * @return Success
   */
  GetUpdateDistrict(id: string): __Observable<UpdateDistrictCommand> {
    return this.GetUpdateDistrictResponse(id).pipe(
      __map(_r => _r.body as UpdateDistrictCommand)
    );
  }

  /**
   * @param params The `DistrictService.UpdateDistrictParams` containing the following parameters:
   *
   * - `id`:
   *
   * - `command`:
   */
  UpdateDistrictResponse(params: DistrictService.UpdateDistrictParams): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    __body = params.command;
    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl + `/api/organization/districts/${params.id}/update`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * @param params The `DistrictService.UpdateDistrictParams` containing the following parameters:
   *
   * - `id`:
   *
   * - `command`:
   */
  UpdateDistrict(params: DistrictService.UpdateDistrictParams): __Observable<null> {
    return this.UpdateDistrictResponse(params).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * @param id undefined
   */
  DeleteDistrictResponse(id: string): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/api/organization/districts/${id}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * @param id undefined
   */
  DeleteDistrict(id: string): __Observable<null> {
    return this.DeleteDistrictResponse(id).pipe(
      __map(_r => _r.body as null)
    );
  }
}

module DistrictService {

  /**
   * Parameters for GetAll
   */
  export interface GetAllParams {
    sortFields?: Array<any>;
    sortCriteria?: Array<any>;
    pattern?: string;
    pageSize?: number;
    pageNumber?: number;
    governorateId?: string;
  }

  /**
   * Parameters for UpdateDistrict
   */
  export interface UpdateDistrictParams {
    id: string;
    command?: UpdateDistrictCommand;
  }
}

export { DistrictService }
